export const demoData = [
    {name:"Demo1",id:1, url:"https://m.media-amazon.com/images/I/61TD5JLGhIL._SX3000_.jpg"},
    {name:"Demo2",id:2, url:"https://m.media-amazon.com/images/I/71qid7QFWJL._SX3000_.jpg"},
    {name:"Demo3",id:3, url:"https://m.media-amazon.com/images/I/61N83xtyr6L._SX3000_.jpg"},
    {name:"Demo4",id:4, url:"https://m.media-amazon.com/images/I/61jovjd+f9L._SX3000_.jpg"},
]

export const themeData = [
    {name:"light", id:1, add:"Light", bgcolor:"#ffffff"},
    {name:"dark", id:2,  add:"Dark", bgcolor:"#89EBC7"},
    {name:"navi", id:3, add:"Navi", bgcolor:"#7CA5F2"},
]